import { Component, Input, Output, EventEmitter, HostBinding, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepperItem } from '../stepper.types';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'sm-stepper-step',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stepper-step.component.html',
  styleUrls: ['./stepper-step.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('expandCollapse', [
      state(
        'open',
        style({
          height: '*',
          opacity: 1,
          overflow: 'hidden',
        })
      ),
      state(
        'closed',
        style({
          height: '0px',
          opacity: 0,
          overflow: 'hidden',
        })
      ),
      transition('closed => open', [
        style({ height: '0px', opacity: 0, overflow: 'hidden' }),
        animate('300ms ease-out', style({ height: '*', opacity: 1 })),
      ]),
      transition('open => closed', [style({ overflow: 'hidden' }), animate('300ms ease-in', style({ height: '0px', opacity: 0 }))]),
    ]),
  ],
})
export class StepperStepComponent {
  @Input() item!: StepperItem;
  @Input() active = false;
  @Input() disabled = false;

  /** Optional callback when a step is activated */
  @Input() onActivate?: (value: number) => void;

  @Output() activated = new EventEmitter<number>();

  handleKeydown(event: KeyboardEvent): void {
    if (!this.disabled && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      this.activate();
    }
  }

  activate() {
    if (!this.disabled) {
      this.onActivate?.(this.item.value);
      this.activated.emit(this.item.value);
    }
  }

  // Add a class for active state if you need styling hooks
  @HostBinding('class.active') get isActive() {
    return this.active;
  }
}
